/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePackageCheckoutSessionDto } from '../../models/create-package-checkout-session-dto';
import { ResponseCheckoutSessionDto } from '../../models/response-checkout-session-dto';

export interface CheckoutSessionsControllerCreatePackageCheckoutSession$Params {
      body: CreatePackageCheckoutSessionDto
}

export function checkoutSessionsControllerCreatePackageCheckoutSession(http: HttpClient, rootUrl: string, params: CheckoutSessionsControllerCreatePackageCheckoutSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseCheckoutSessionDto>> {
  const rb = new RequestBuilder(rootUrl, checkoutSessionsControllerCreatePackageCheckoutSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseCheckoutSessionDto>;
    })
  );
}

checkoutSessionsControllerCreatePackageCheckoutSession.PATH = '/keus-payments/checkout-sessions/package';
